import styled from '@emotion/styled';
import { IAnnouncement, ANNOUNCEMENT_CATEGORY_LABELS } from 'domain/entities/Announcement/Announcement';
import dayjs from 'dayjs';
import { convertUrlsToLinks } from 'utils/text';

const Header = styled.div`
    margin-bottom: 20px;
`;

const Title = styled.h2`
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--dark-blue);
    margin-bottom: 16px;
`;

const MetaInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
`;

const Category = styled.span<{ category?: string }>`
    display: inline-block;
    padding: 4px 12px;
    background-color: ${(props) => (props.category === 'agent_news' ? '#4CAF50' : 'var(--orange)')};
    color: white;
    border-radius: 4px;
    font-size: 0.875rem;
`;

const Date = styled.span`
    color: #666;
    font-size: 0.875rem;
`;

const Content = styled.div`
    font-size: 1rem;
    line-height: 1.6;
    color: var(--text);
    white-space: pre-wrap;
    word-break: break-word;

    a {
        color: var(--blue);
        text-decoration: underline;
        &:hover {
            text-decoration: none;
        }
    }
`;

interface Props {
    announcement: IAnnouncement;
    onClose: () => void;
}

/**
 * お知らせ詳細モーダル
 */
export const AnnouncementDetail: React.FC<Props> = ({ announcement }) => {
    return (
        <>
            <Header>
                <Title>{announcement.title}</Title>
                <MetaInfo>
                    {announcement.category && (
                        <Category category={announcement.category}>
                            {ANNOUNCEMENT_CATEGORY_LABELS[announcement.category]}
                        </Category>
                    )}
                    <Date>{dayjs(announcement.created_at).format('YYYY.MM.DD')}</Date>
                </MetaInfo>
            </Header>
            <Content>{convertUrlsToLinks(announcement.content)}</Content>
        </>
    );
};
